import { Stack, Typography } from "@mui/material";
import ENTITY_TYPE from "enums/ENTITY_TYPE";
import useCreateOrUpdateEntityNote from "hooks/api/useCreateOrUpdateEntityNote";
import useGetEntityNotes from "hooks/api/useGetEntityNotes";
import { flexCentered } from "../../../theme/base/flex";
import NewNote from "./NewNote";
import Note from "./Note";

interface Props {
  entityType: ENTITY_TYPE;
  entityId: string;
}

export default function EntityNotes({ entityType, entityId }: Props) {
  const { mutate, notes: _notes } = useGetEntityNotes(entityType, entityId);
  const { createOrUpdateEntityNote } = useCreateOrUpdateEntityNote(
    entityType,
    entityId,
  );
  const notes = _notes || [];

  return (
    <Stack spacing={2} sx={{ minWidth: "22rem" }}>
      <NewNote
        onSave={async (content: string) => {
          await createOrUpdateEntityNote({ content });
          mutate();
        }}
      />
      {notes.length === 0 ? (
        <Stack sx={{ flex: 1, width: "100%", height: "100%", ...flexCentered }}>
          <Typography variant="h6">
            {`There are no notes to show for this ${entityType.toLowerCase()}`}
          </Typography>
        </Stack>
      ) : (
        notes
          .sort((a, b) => {
            const aCreatedOn = a.createdOn ?? 0;
            const bCreatedOn = b.createdOn ?? 0;
            return bCreatedOn - aCreatedOn;
          })
          .map((note) => <Note key={note.id} note={note} />)
      )}
    </Stack>
  );
}
